import { DateTime } from 'luxon';

export const hashStringToNumber = (str, min, max) =>
  min + (str.split('').reduce((a, b) => a + b.charCodeAt(0), 0) % (max - min)) + 1;

export const getReviewStateShort = (reviewState) => {
  switch (reviewState) {
    case 'first_round':
      return 'Reviews';
    case 'discussion':
      return 'Discussion';
    case 'author_response':
      return 'Response';
    default:
      return 'Reviews';
  }
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const intersects = (array1, array2) => array1.filter((value) => array2.includes(value)).length > 0;

export const sum = (array) => array.reduce((a, b) => a + b, 0);

export const calcDeadline = (paper, possibleStates) => {
  const startTime = (paper.stateUpdateTime === undefined && DateTime.now()) || DateTime.fromISO(paper.stateUpdateTime);
  const currState = possibleStates.filter((state) => state.name === paper.reviewState); // check what if not exist
  const timelimit = currState[0].time_limit || null;
  const deadline = startTime.plus({ days: timelimit });
  return deadline;
};
